import { Box, Button, Card, Container, Flex, Heading, ScrollArea, Spinner, Text } from "@radix-ui/themes"
import React, { useEffect, useRef, useState } from "react"
import {IPoster} from '../../core/types/services-types/poster-types'
import PosterRender from "../../components/common/renders/poster-render"
import {InfoCircledIcon, ReloadIcon} from '@radix-ui/react-icons'
import useFetch from '../../core/hooks/useFetch'
import PosterService from '../../core/services/PosterService'
import { PUBLIC_ROUTES, } from "../../routes/constants"
import { IUser } from "../../core/types/services-types/user-types"
import { ISettings } from "../../core/types/services-types/admin-types"
import {useAppSelector} from '../../core/store'
import AdminService from '../../core/services/AdminService'
import useObserver from '../../hooks/useObserver'
import { Link } from "react-router"
export default function Main() {
    const [limit, setLimit] = useState(100)
    const [page, setPage] = useState(0)
    const [total, setTotal] = useState(0)
  
    const [posters, setPosters] = useState<IPoster[]>([])
    const [user, setUser] = useState<IUser>()
    const [settingsSite, setSettingsSite] = useState<ISettings>()



  const userData = useAppSelector(store => store.user.user)



    const [fetchPosters, isLoading, error, errors] = useFetch(async () => {
      console.log(page)
        const data = await PosterService.GetAll(limit, page)
        setPosters(prev => prev.concat(data.data))
        setTotal(data.count)
    })

    const [fetchSettingsSite, isLoadingSettingsSite, errorSettingsSite, errorsSettingsSite] = useFetch(async () => {
      const data = await AdminService.GetSettingsSite()
      setSettingsSite(data)
    })


    useEffect(() => {
        fetchPosters()
    }, [page])

    useEffect(() => {
      fetchSettingsSite()
    }, [])

    const reloadPosters = async () => {
        setPage(0)
        setPosters([])
        await fetchPosters()
    }


  const endRef = useRef<HTMLDivElement>(null);  

  useObserver({
  ref: endRef,
  canLoad: total > posters.length || posters.length <= 0,
  isLoading: isLoading,
  callback: () => setPage(prev => prev + 1)
})

    useEffect(() => {
      setUser(userData)
    }, [userData])

    return (
      <Box>
        {isLoadingSettingsSite ? 
        <Spinner />
        :
        <Container 
        style={{
          backgroundImage: `url(${settingsSite?.background_main_page})`
        }}
        className="h-screen bg-cover bg-center"
        >
          <Card className="p-10 mb-10 rounded-lg mt-10">
            <Flex justify={'between'}>
               <Heading>
                Лента новостей
                </Heading>
                <Button variant='outline' loading={isLoading} onClick={async () => await reloadPosters()}>
                    Обновить
                    <ReloadIcon />
                </Button>
            </Flex>
            { !user ?
            <Flex align={'center'} justify={'between'} gap={'3'} wrap={'wrap'}> 
            <Link to={PUBLIC_ROUTES.LOGIN_ROUTE} className="container !w-[100%]"> 
            <Flex align={'center'} gap={'1'} className="bg-green-400 container rounded-lg p-5 mt-5 hover:shadow-2xl cursor-pointer">
            <InfoCircledIcon color="white" />
             
            <Text style={{color: 'white'}} weight={'medium'}>
              Авторизируйтесь, чтобы видеть все новости проекта!
            </Text>
            
            </Flex>
 </Link>
            </Flex>
            :
            ''
            }
            </Card>
            <ScrollArea type="always" scrollbars="vertical" style={{height: '630px', scrollbarWidth: 'none'}}> 
            {
                posters.length ? 
                posters?.map(poster => {
                    return (
                        <Card className="p-10 mb-10 rounded-lg shadow-lg">
                        <PosterRender poster={poster} />
                        </Card>
                    )
                })
                :
                <Spinner size={'3'} />
            }
            <div className="end mb-5 h-[20px]" ref={endRef}></div>
             </ScrollArea>
        </Container>
       
}
        </Box>
        
    )
}